module.exports = __webpack_public_path__ + "img/92109.7c5fd00d.svg";